/**
 * Shared date formatting utilities.
 * Consolidates duplicate toLocaleDateString patterns across the codebase.
 */

/** "Mar 15, 2026" */
export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return "---";
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/** "Mar 15, 2026" — always interprets the date in UTC (for date-only values). */
export function formatDateUtc(dateStr: string | null | undefined): string {
  if (!dateStr) return "---";
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}

/** "Mar 15" */
export function formatDateShort(dateStr: string | null | undefined): string {
  if (!dateStr) return "---";
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
}

/** "Mar 15, 2:30 PM" */
export function formatDateTime(dateStr: string | null | undefined): string {
  if (!dateStr) return "---";
  const d = new Date(dateStr);
  const date = d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
  const time = d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
  return `${date}, ${time}`;
}

/** "2:30 PM" */
export function formatTime(dateStr: string | null | undefined): string {
  if (!dateStr) return "---";
  return new Date(dateStr).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
}

/** "6/3, 2:30 PM" — compact note timestamp (numeric month/day, no year).
 *  Shared by the activity feed and the kanban hover preview. */
export function formatNoteDate(dateStr: string | null | undefined): string {
  if (!dateStr) return "---";
  const d = new Date(dateStr);
  return `${d.getMonth() + 1}/${d.getDate()}, ${formatTime(dateStr)}`;
}
